import React from 'react'
import Imgbody from './Imgbody'
import Footer from './Footer'

const Home = () => {
  return (
    <div>
      <div className='main'>
          <Imgbody/>
      </div>
      <Footer/>
    </div>
  )
}

export default Home
